export enum IncomeStatementGroupType {
    REVENUE = 'REVENUE',
    OPERATIONAL = 'OPERATIONAL'
}